import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import EditDeleteButton from '../shared/buttons/EditDeleteButton';
import formatter from '../../utilities/formatter';
import postData from '../../utilities/postData';
import PropTypes from 'prop-types';

const ProposalItem = (props) => {
    const { item } = props;

    const deleteUrl = '/api/proposals/delete/' + item.id;

    function deleteItem() {
        postData(deleteUrl, null, () => {
            props.fetchData();
            window.dispatchEvent(new Event('updateChangeLog'));
        });
    }

    return (
        <tr>
            <CustomTd content={item.proposalNumber} />
            <CustomTd content={formatter.currency(item.total)} />
            <CustomTd content={formatter.date(item.dateCreated)} />
            <CustomTd className="button-cell">
                <EditDeleteButton
                    deleteItem={deleteItem}
                    viewItem={props.editItem}
                    editItem={props.editItem}
                    showText={false}
                    acl={item.acl}
                />
            </CustomTd>

        </tr>
    );
}

ProposalItem.propTypes = {
    deleteUrl: PropTypes.string,
    editItem: PropTypes.func,
    fetchData: PropTypes.func
};

export default ProposalItem;